import { render } from "./spot-offer.vue?vue&type=template&id=5106b256&scoped=true"
import script from "./spot-offer.vue?vue&type=script&lang=js"
export * from "./spot-offer.vue?vue&type=script&lang=js"

import "./spot-offer.vue?vue&type=style&index=0&id=5106b256&lang=scss&scoped=true"

import exportComponent from "/home/node/ks-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5106b256"]])

export default __exports__